<template>
    <td-dialog
        :title="$t(title)"
        append-to-body="true"
        :before-close="roleDialogClose"
        :visible.sync="dialogRoleVisible"
        width="600px"
        height="460px"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        top="18vh"
    >
        <el-container>
            <el-header>
                <el-form :inline="true" :model="fromRole" ref="fromRole" :rules="rules" label-position="right" label-width="120px">
                    <el-row :gutter="20">
                        <el-col>
                            <el-form-item :label="$t('pgCommon.SET_ORG')">
                                <td-tree-select
                                    ref="tdOrgTree"
                                    nodeKey="id"
                                    :defaultProps="deviceProps"
                                    :imgloading="true"
                                    :multiple="true"
                                    :interfaceName="interfaceName"
                                    :calInternal="true"
                                    :params="params"
                                    :lazyloading="true"
                                    v-model="fromRole.roleIds"
                                    :width="300"
                                    :showBox="true"
                                    :expandOnClick="true"
                                ></td-tree-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </el-header>
        </el-container>
        <span slot="footer" style="text-align:left">
            <td-button type="primary" @click="save">{{ $t('pgCommon.SAVE') }}</td-button>
            <td-button @click="roleDialogClose">{{ $t('pgCommon.CANCEL') }}</td-button>
        </span>
    </td-dialog>
</template>
<script>
import Api from './../assets/api.js';
export default {
    props: ['title', 'dialogRoleVisible', 'templateKey', 'roleParam'],
    created() {
        if (this.$common.systemInfo.systemId) {
            this.fromRole.sSysFlg = this.$common.systemInfo.systemId;
        } else {
            this.fromRole.sSysFlg = 'PG';
        }
    },
    // 在页面渲染完成之后进行初始化工作
    mounted() {
        // this.rowDrop()
        // this.queryPageList(); // 进行页面初始化数据的加载
        this.queryFeedBack();
    },
    // 定义数据
    data() {
        return {
            deviceProps: {
                parentId: 'parentId',
                children: 'children',
                id: 'id',
                label: 'caption',
                imgName: 'sIcon'
            },
            params: {
                // needPage: true
            },
            interfaceName: { query: '/OrgStructureController/findOrgStructureTree', search: '/OrgStructureController/findOrgStructureTree' },
            fromRole: {
                roleName: '',
                deptType: '',
                sSysFlg: ''
            },
            permissionsAdd: ['role:add'],
            permissionsEdit: ['role:edit'],
            permissionsView: ['role:view'],
            permissionsDel: ['role:del'],
            sysList: [],
            sysAndFlgList: [],
            orgTypeList: [{ orgType: '', orgName: this.$t('pgCommon.ALL') }, { orgType: '0', orgName: this.$t('pgCommon.NORMAL_ROLE') }, { orgType: '1', orgName: this.$t('pgCommon.ORG_ROLE') }],
            menuUrl: '',
            deptUrl: '',
            hostUrl: '',
            tableData: [],
            selectRows: [],
            roleIds: [],
            roleNames: [],
            currPage: [],
            isAddData: true, // 是否为添加数据
            pageSize: 10, // 每页条数
            currentPage: 1, // 当前页
            total: 0, // 总条数
            loading: false, // 按钮是否为加载状态
            orgTreeUrl: { query: '', search: '' },
            // 对表单进行数据验证
            rules: {
                roleName: [
                    {
                        pattern: this.$regex.ROLECAPTION_RULE,
                        message: this.$t('error.ERROR_ROLE_CAPTION_ILLEGAL')
                    }
                ]
            },
            columns: [
                {
                    prop: 'roleName',
                    label: this.$t('pgCommon.ROLENAME')
                },
                {
                    prop: 'authName',
                    label: this.$t('pgCommon.ROLE_TYPE'),
                    render: (createElement, params) => {
                        let res = params.row.sParam;
                        if (params.row.deptType === '0') {
                            res = this.$t('pgCommon.NORMAL_ROLE');
                        } else {
                            res = this.$t('pgCommon.ORG_ROLE');
                        }
                        return createElement('div', res);
                    }
                },
                {
                    prop: 'roleDescription',
                    label: this.$t('pgCommon.DESCRIPTION')
                }
            ]
        };
    },
    // 方法的实现
    methods: {
        // 获取每页条数
        handleSizeChange(pageSize) {
            this.pageSize = pageSize;
            this.submit();
        },
        // 获取当前页
        currentChange(currentPage) {
            this.currentPage = currentPage;
            this.submit();
        },
        queryPageList() {
            this.currentPage = 1;
            // this.getMenuUrl();
            this.btnQuery();
        },
        // 查询数据
        btnQuery() {
            this.loading = true;
            let param = {
                sysFlg: this.fromRole.sSysFlg,
                roleName: this.fromRole.roleName,
                deptType: this.fromRole.deptType,
                currentPage: this.currentPage,
                pageSize: this.pageSize
            };
            Api.listRoleInfos(JSON.stringify(param), response => {
                if (this.$t(this.$common.requestCode.SUCCESS_INFO_CODE) != response.data.statusCode) {
                    this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                    this.$log.error('role/getRoleAuthList', response.data.statusMessage);
                    return;
                }
                this.tableData = response.data.content;
                this.total = response.data.count;
                this.loading = false;
                this.feedBack();
            });
        },
        select: function(selection) {
            let roleArr = [];
            let nameArr = [];
            for (let item in this.tableData) {
                roleArr.push(this.tableData[item].roleId);
                nameArr.push(this.tableData[item].roleName);
            }
            for (let item in selection) {
                if (roleArr.indexOf(selection[item].roleId) > -1) {
                    nameArr.splice(roleArr.indexOf(selection[item].roleId), 1);
                    roleArr.splice(roleArr.indexOf(selection[item].roleId), 1);
                }
            }
            for (let item in this.roleIds) {
                for (let roleItem in roleArr) {
                    if (roleArr[roleItem] == this.roleIds[item] && nameArr[roleItem] == this.roleNames[item]) {
                        this.roleIds.splice(item, 1);
                        this.roleNames.splice(item, 1);
                    }
                }
            }
            for (let item in selection) {
                if (this.roleIds.indexOf(selection[item].roleId) == -1) {
                    this.roleIds.push(selection[item].roleId);
                    this.roleNames.push(selection[item].roleName);
                }
            }
        },
        save: function() {
            this.loading = true;
            let roleIdStr = '';
            let roleNameStr = '';
            // if (this.roleIds.length > 40) {
            //     this.loading = false;
            //     this.$message({ showClose: true, message: this.$t('pgCommon.CANT_SELECT_40'), type: 'warning' });
            //     return;
            // }
            // for (let i = 0; i < this.roleIds.length; i++) {
            //     if (roleIdStr == '' && roleNameStr == '' && typeof this.roleIds[i] != 'undefined' && typeof this.roleNames[i] != 'undefined') {
            //         roleIdStr += this.roleIds[i];
            //         roleNameStr += this.roleNames[i];
            //     } else if (typeof this.roleIds[i] != 'undefined' && typeof this.roleNames[i] != 'undefined') {
            //         roleIdStr += ',' + this.roleIds[i];
            //         roleNameStr += ',' + this.roleNames[i];
            //     }
            // }
            for (let obj in this.fromRole.roleIds) {
                if ('86884ef8664e41e18effd8bb53d95482' != this.fromRole.roleIds[obj].id) {
                    if (roleIdStr === '') {
                        roleIdStr += this.fromRole.roleIds[obj].id;
                        if (undefined != this.fromRole.roleIds[obj].orgName && 'undefined' != this.fromRole.roleIds[obj].orgName) {
                            roleNameStr += this.fromRole.roleIds[obj].orgName;
                        } else {
                            roleNameStr += this.$t('pgCommon.NOT_HAVE');
                        }
                    } else {
                        roleIdStr += ',' + this.fromRole.roleIds[obj].id;
                        if (undefined != this.fromRole.roleIds[obj].orgName && 'undefined' != this.fromRole.roleIds[obj].orgName) {
                            roleNameStr += ',' + this.fromRole.roleIds[obj].orgName;
                        } else {
                            roleNameStr += ',' + this.$t('pgCommon.NOT_HAVE');
                        }
                    }
                }
            }
            if (!this.fromRole.roleIds.length || this.fromRole.roleIds.length == 0) {
                roleIdStr = "null";
            }
            let param = {
                processDefKey: this.templateKey,
                taskDefKey: this.roleParam.taskKey,
                roleIds: roleIdStr,
                roleNames: roleNameStr,
                flag: this.roleParam.tasksFlag,
                proDefId: this.templateKey + ':TEMP',
            };
            Api.saveNodeUser(JSON.stringify(param), response => {
                if (this.$t(this.$common.requestCode.SUCCESS_INFO_CODE) != response.data.statusCode) {
                    this.loading = false;
                    this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                    this.$log.error('role/getRoleAuthList', response.data.statusMessage);
                    return;
                }
                this.$message({ showClose: true, message: this.$t('pgCommon.ADD_SUCCESS'), type: 'success' });
                this.roleDialogClose();
            });
        },
        // 回显
        feedBack() {
            this.loading = true;
            for (let i in this.currPage) {
                for (let j in this.tableData) {
                    if (this.tableData[j].roleId == this.currPage[i]) {
                        this.$refs.fromRoleList.toggleRowSelection(this.tableData[j], true);
                    }
                }
            }
            this.loading = false;
        },
        // 查询回显数据
        queryFeedBack() {
            this.loading = true;
            let param = {
                sId: this.templateKey + this.roleParam.taskKey,
                processDefKey: this.templateKey,
                taskDefKey: this.roleParam.taskKey,
                proDefId: this.templateKey + ':TEMP',
            };
            Api.queryNodeUser(JSON.stringify(param), response => {
                if (response.status !== this.$common.login.RESPONSE_STATUS) {
                    this.$message({ type: 'error', showClose: true, message: this.$t('error.ERROR_RESPONSE') });
                    this.loading = false;
                    this.$log.error('queryNodeUser', response);
                    return;
                }
                if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                    this.$message({ type: 'error', showClose: true, message: response.data.statusMessage });
                    this.$log.error('queryNodeUser', response.data.statusMessage);
                    return;
                }
                if (response.data.content.length > 0) {
                    let roleStr = response.data.content[0].roleIds;
                    let roleNameStr = response.data.content[0].roleNames;
                    if (null != roleStr && '' != roleStr) {
                        let arr = new Array();
                        let arrName = new Array();
                        let objs = [];
                        arr = roleStr.split(',');
                        arrName = roleNameStr.split(',');
                        for (let key in arr) {
                            let obj = { id: arr[key], caption: arrName[key] };
                            objs.push(obj);
                        }
                        this.$refs.tdOrgTree.dataDisplay(objs);
                    }
                }
                this.loading = false;
            });
        },
        // 组件关闭需要调用的方法
        submit() {
            this.btnQuery();
        },
        //关闭角色dialog
        roleDialogClose: function() {
            this.$emit('roleDialogClose');
            this.dialogRoleVisible = false;
        }
    }
};
</script>
